import { Col, Pagination, Row } from 'antd';
import { DocumentCard } from 'features/Dashboard/ui/DocumentCard';
import { Fragment } from 'react';

export const PendingDocumentsView = ({
  pendingDocument,
  setAddCommentsModal,
  setCommentsInfo,
  itemsPerPage,
  currentPage,
  setCurrentPage,
}: any) => {
  // Pagination calculations
  const totalRecords = pendingDocument?.rc?.[0]?.totalRecords || 0;
  const paginatedData = pendingDocument?.rc;
  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const handleAddComment = (document: any) => {
    setAddCommentsModal(true);
    setCommentsInfo(document);
  };

  return (
    <Fragment>
      <Row gutter={[16, 16]} justify='start' align='top' className='mb-4'>
        {paginatedData?.map((item: any, index: number) => (
          <Col
            key={index}
            xxl={6}
            xl={8}
            lg={10}
            md={12}
            sm={24}
            role='button'
            className='self-stretch'
          >
            {' '}
            {/* Adjust column span for responsive layout */}
            <DocumentCard document={item} onAddComment={handleAddComment} />
          </Col>
        ))}
      </Row>
      {/* Pagination Component */}
      {totalPages > 1 && (
        <Pagination
          current={currentPage}
          pageSize={itemsPerPage}
          total={totalRecords}
          onChange={(page) => setCurrentPage(page)}
          showSizeChanger={false} // Hides the page size dropdown
          // style={{ textAlign: 'center', marginTop: '20px' }}
        />
      )}
    </Fragment>
  );
};
